/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-study-visit-schedules.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

// Predicate to pass in to, e.g., Array.prototype.filter to get rid of null and undefined values
// and ensure return type of array is updated accordingly (to not include `| null | undefined`)
// Taken from https://stackoverflow.com/a/46700791
export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue => {
    if (value === null || value === undefined) return false;
    const testDummy: TValue = value;
    return true;
};
